module.exports = __webpack_public_path__ + "img/Logo_taxert.64ceed64.svg";